import { AppDispatch } from 'store'
import { getShifts } from 'features/shifts/shiftsSlice'
import { getClientRoles } from 'features/roles/clientRolesSlice'
import { getCapabilities } from 'features/capabilities/capabilitiesSlice'

export const fetchCoverageRegistries = (dispatch: AppDispatch): Promise<unknown> =>
  Promise.all([
    dispatch(getShifts({ page: 1, limit: 99, includeAbsent: false })),
    dispatch(getClientRoles({ page: 1, limit: 99 })),
    dispatch(getCapabilities({ page: 1, limit: 99 })),
  ])
